module.exports = {"id":"143809","name":"Muhammet Demir","rating":"74","photo":"./data/images/photos/3/143809.png","club":{"name":"Sivasspor","logo":"./data/images/clubs/Sivasspor.png"},"positions":["BU","MOC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MuhammetDemir0.json
// module id = 3101
// module chunks = 0